import componentFn from '../../styles/objects/component'
import { important } from '../../styles/tools/parsers'

export default ({
  colors,
  spacings,
  images,
  fontFamilies,
  fontWeights,
  fontSizes,
  textTransforms
}) => {
  const component = componentFn({
    colors,
    spacings,
    images,
    fontFamilies,
    fontWeights,
    fontSizes,
    textTransforms
  })

  const styles = {
    label: {
      fontFamily: fontFamilies.alternate,
      marginBottom: '0',
      ':not(:first-child)': {
        marginTop: '0'
      }
    },

    'label--small': {
      fontSize: '13px'
    },

    'label--padded': {
      marginTop: important('2rem')
    }
  }

  return { ...component, ...styles }
}



// WEBPACK FOOTER //
// ./components/labelWithLink/styles.js